import { render } from "./ThemeSwitcher.vue?vue&type=template&id=d8fc409a&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"

import "./ThemeSwitcher.vue?vue&type=style&index=0&id=d8fc409a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fc409a"]])

export default __exports__